import Splide from '@splidejs/splide';

const EL = '.js-show'
const ELS = document.querySelectorAll(EL);

ELS.forEach((EL) => {
  new Splide( EL, {
    arrows: true,
    pagination: true,
  } ).mount();
});
